import type { ModelDefinition, ResponseMode } from "./types";

export const DEFAULT_MODEL_ID = "qwen3-1.7b";

export const MODELS: ModelDefinition[] = [
  {
    id: "qwen3-0.6b-fast",
    family: "Qwen 3",
    name: "Qwen 3 0.6B Fast",
    parameterLabel: "0.6B / 高速起動",
    sourceRepo: "Qwen/Qwen3-0.6B",
    runtimeRepo: "onnx-community/Qwen3-0.6B-ONNX",
    runtimeRevision: "da1453100cf3ff33ef56d17983fc7a8648706db6",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 570 MB",
    minimumGpuMemory: "約 1 GB",
    contextLimit: 8192,
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "軽量な補助モデル。Fast利用や投機パイプラインの下書き向けです。",
  },
  {
    id: "qwen3-1.7b",
    family: "Qwen 3",
    name: "Qwen 3 1.7B",
    parameterLabel: "1.7B",
    sourceRepo: "Qwen/Qwen3-1.7B",
    runtimeRepo: "onnx-community/Qwen3-1.7B-ONNX",
    runtimeRevision: "cc6a06a21d614e9b8e92a6adfab1074d4e7d2438",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 1.43 GB",
    minimumGpuMemory: "約 2 GB",
    contextLimit: 8192,
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "日常利用向け。Thinkingの切り替えに対応する既定モデルです。",
  },
  {
    id: "qwen3-4b",
    family: "Qwen 3",
    name: "Qwen 3 4B",
    parameterLabel: "4B",
    sourceRepo: "Qwen/Qwen3-4B",
    runtimeRepo: "onnx-community/Qwen3-4B-ONNX",
    runtimeRevision: "98ddba15d05dede4435afb63f13280abcdbc2a48",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 2.6 GB",
    minimumGpuMemory: "約 4 GB",
    contextLimit: 8192,
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "品質重視。サーバー側の準備に時間がかかります。",
  },
  {
    id: "qwen3-8b",
    family: "Qwen 3",
    name: "Qwen 3 8B",
    parameterLabel: "8B",
    sourceRepo: "Qwen/Qwen3-8B",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "サーバー側ランタイムの設定が必要です。",
  },
  {
    id: "qwen3-14b",
    family: "Qwen 3",
    name: "Qwen 3 14B",
    parameterLabel: "14B",
    sourceRepo: "Qwen/Qwen3-14B",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "高メモリ環境と専用変換が必要です。",
  },
  {
    id: "qwen3-30b-a3b",
    family: "Qwen 3",
    name: "Qwen 3 30B-A3B",
    parameterLabel: "30B / active 3B",
    sourceRepo: "Qwen/Qwen3-30B-A3B",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "MoEモデル。サーバー側ランタイムの設定が必要です。",
  },
  {
    id: "qwen3-32b",
    family: "Qwen 3",
    name: "Qwen 3 32B",
    parameterLabel: "32B",
    sourceRepo: "Qwen/Qwen3-32B",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "qwen3",
    note: "専用ランタイムまたはリモート実行向けです。",
  },
  {
    id: "deepseek-r1-1.5b",
    family: "DeepSeek R1 Distill",
    name: "DeepSeek R1 Distill Qwen 1.5B",
    parameterLabel: "1.5B",
    sourceRepo: "deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B",
    runtimeRepo: "onnx-community/DeepSeek-R1-Distill-Qwen-1.5B-ONNX",
    runtimeRevision: "da4eb3f7ffdad868d21cab06d375b444dc83fbef",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 1.1 GB",
    minimumGpuMemory: "約 2 GB",
    contextLimit: 8192,
    supportsThinking: true,
    promptAdapter: "deepseek",
    note: "公式推奨に合わせ、SYSPRMPTは先頭ユーザー指示へ安全に統合します。",
  },
  {
    id: "deepseek-r1-7b",
    family: "DeepSeek R1 Distill",
    name: "DeepSeek R1 Distill Qwen 7B",
    parameterLabel: "7B",
    sourceRepo: "deepseek-ai/DeepSeek-R1-Distill-Qwen-7B",
    browserSupport: "high-memory",
    engine: "server",
    minimumGpuMemory: "約 5.1 GB",
    supportsThinking: true,
    promptAdapter: "deepseek",
    note: "WebLLM形式は存在しますが、このビルドの実行エンジン外です。",
  },
  {
    id: "deepseek-r1-8b",
    family: "DeepSeek R1 Distill",
    name: "DeepSeek R1 Distill Llama 8B",
    parameterLabel: "8B",
    sourceRepo: "deepseek-ai/DeepSeek-R1-Distill-Llama-8B",
    browserSupport: "high-memory",
    engine: "server",
    minimumGpuMemory: "約 5.0 GB",
    supportsThinking: true,
    promptAdapter: "deepseek",
    note: "WebLLM形式は存在しますが、このビルドの実行エンジン外です。",
  },
  ...[14, 32, 70].map<ModelDefinition>((size) => ({
    id: `deepseek-r1-${size}b`,
    family: "DeepSeek R1 Distill",
    name: `DeepSeek R1 Distill ${size === 70 ? "Llama" : "Qwen"} ${size}B`,
    parameterLabel: `${size}B`,
    sourceRepo: `deepseek-ai/DeepSeek-R1-Distill-${size === 70 ? "Llama" : "Qwen"}-${size}B`,
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "deepseek",
    note: "専用変換済みランタイムと大容量メモリが必要です。",
  })),
  {
    id: "gemma4-e2b",
    family: "Gemma 4",
    name: "Gemma 4 E2B IT",
    parameterLabel: "effective 2.3B",
    sourceRepo: "google/gemma-4-E2B-it",
    runtimeRepo: "onnx-community/gemma-4-E2B-it-ONNX",
    runtimeRevision: "9f4bef82ea6e296bc69f8a2f5939f73af81b07a6",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 3 GB",
    minimumGpuMemory: "約 4 GB",
    contextLimit: 8192,
    supportsThinking: false,
    promptAdapter: "standard",
    note: "Thinking選択時は高品質設定に変換します。",
  },
  {
    id: "gemma4-e4b",
    family: "Gemma 4",
    name: "Gemma 4 E4B IT",
    parameterLabel: "effective 4.5B",
    sourceRepo: "google/gemma-4-E4B-it",
    runtimeRepo: "onnx-community/gemma-4-E4B-it-ONNX",
    runtimeRevision: "843f250f23bc91754def1e0f0db390dacd1e6b05",
    dtype: "q4f16",
    browserSupport: "ready",
    engine: "server",
    estimatedDownload: "約 5 GB",
    minimumGpuMemory: "約 6 GB",
    contextLimit: 8192,
    supportsThinking: false,
    promptAdapter: "standard",
    note: "高性能GPUサーバー向けです。",
  },
  ...[
    ["12b", "12B"],
    ["26b-a4b", "26B-A4B"],
    ["31b", "31B"],
  ].map<ModelDefinition>(([slug, label]) => ({
    id: `gemma4-${slug}`,
    family: "Gemma 4",
    name: `Gemma 4 ${label} IT`,
    parameterLabel: label,
    sourceRepo: `google/gemma-4-${label}-it`,
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: false,
    promptAdapter: "standard",
    note: "サーバー側ランタイムの設定が必要です。",
  })),
  {
    id: "gpt-oss-20b",
    family: "GPT-OSS",
    name: "GPT-OSS 20B",
    parameterLabel: "21B / active 3.6B",
    sourceRepo: "openai/gpt-oss-20b",
    runtimeRepo: "onnx-community/gpt-oss-20b-ONNX",
    runtimeRevision: "6dcc680ae66791268a1e4e96fc3bfd0e5d3662e7",
    dtype: "q4",
    browserSupport: "high-memory",
    engine: "server",
    estimatedDownload: "10 GB超",
    minimumGpuMemory: "約 12 GB",
    supportsThinking: true,
    promptAdapter: "gpt-oss",
    note: "実験枠。一般的な協力端末ではGPUメモリ不足になる可能性が高いモデルです。",
  },
  {
    id: "gpt-oss-120b",
    family: "GPT-OSS",
    name: "GPT-OSS 120B",
    parameterLabel: "117B / active 5.1B",
    sourceRepo: "openai/gpt-oss-120b",
    browserSupport: "catalog",
    engine: "server",
    minimumGpuMemory: "約 80 GB級",
    supportsThinking: true,
    promptAdapter: "gpt-oss",
    note: "公式の直接実行形式はなく、単一の一般環境では実行できません。",
  },
  {
    id: "kimi-k3",
    family: "Kimi",
    name: "Kimi K3",
    parameterLabel: "2.8T / active 104B",
    sourceRepo: "moonshotai/Kimi-K3",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "standard",
    note: "Python/vLLM/SGLangなどのサーバー側ランタイム向けです。",
  },
  {
    id: "kimi-k2.7-code",
    family: "Kimi",
    name: "Kimi K2.7 Code",
    parameterLabel: "1T / active 32B",
    sourceRepo: "moonshotai/Kimi-K2.7-Code",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: true,
    promptAdapter: "standard",
    note: "指定名K2.7の公式Repo名はKimi-K2.7-Codeです。サーバー側ランタイム向けです。",
  },
  {
    id: "edge0-35b-a3b-preview",
    family: "Edge0",
    name: "Edge0 35B-A3B Preview",
    parameterLabel: "35B / active 3B",
    sourceRepo: "Edge0/Edge0-35B-A3B-preview",
    browserSupport: "catalog",
    engine: "server",
    supportsThinking: false,
    promptAdapter: "standard",
    note: "専用MLX/SSDストリーミング実装などのサーバー側ランタイム向けです。",
  },
];

export const getModel = (id: string): ModelDefinition =>
  MODELS.find((model) => model.id === id) ?? MODELS[0];

export const MODE_PROFILES: Record<
  ResponseMode,
  { label: string; description: string; temperature: number; maxNewTokens: number }
> = {
  fast: {
    label: "Fast",
    description: "速度優先。短い質問や下書き向け",
    temperature: 0.2,
    maxNewTokens: 256,
  },
  medium: {
    label: "Medium",
    description: "速度と回答品質のバランス",
    temperature: 0.6,
    maxNewTokens: 512,
  },
  thinking: {
    label: "Thinking",
    description: "複雑な問題を丁寧に処理",
    temperature: 0.6,
    maxNewTokens: 1024,
  },
};

export const MODEL_FAMILIES = [
  "Qwen 3",
  "DeepSeek R1 Distill",
  "Gemma 4",
  "GPT-OSS",
  "Kimi",
  "Edge0",
] as const;
